import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ language, onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isAdvanced, setIsAdvanced] = useState(false);
  const [filters, setFilters] = useState({
    fileType: '',
    dateFrom: '',
    dateTo: '',
    owner: ''
  });

  const placeholderLabel = {
    en: 'Search documents...',
    fr: 'Rechercher des documents...',
    ar: 'البحث عن المستندات...'
  };

  const advancedLabel = {
    en: 'Advanced Search',
    fr: 'Recherche avancée',
    ar: 'البحث المتقدم'
  };

  const fileTypeLabel = {
    en: 'File Type',
    fr: 'Type de fichier',
    ar: 'نوع الملف'
  };

  const dateFromLabel = {
    en: 'Date From',
    fr: 'Date de début',
    ar: 'من تاريخ'
  };

  const dateToLabel = {
    en: 'Date To',
    fr: 'Date de fin',
    ar: 'إلى تاريخ'
  };

  const ownerLabel = {
    en: 'Owner',
    fr: 'Propriétaire',
    ar: 'المالك'
  };

  const handleSearch = () => {
    onSearch({
      query: searchQuery,
      filters: isAdvanced ? filters : {}
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <div className="flex-1 relative">
          <Icon
            name="Search"
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            onKeyPress={(e) => e?.key === 'Enter' && handleSearch()}
            placeholder={placeholderLabel?.[language]}
            className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
        <button
          onClick={() => setIsAdvanced(!isAdvanced)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            isAdvanced
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-foreground hover:bg-muted/80'
          }`}
        >
          <Icon name="SlidersHorizontal" size={18} />
        </button>
      </div>
      {isAdvanced && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-muted rounded-lg">
          <Input
            label={fileTypeLabel?.[language]}
            type="text"
            placeholder="PDF, DOCX..."
            value={filters?.fileType}
            onChange={(e) => setFilters({ ...filters, fileType: e?.target?.value })}
          />
          <Input
            label={dateFromLabel?.[language]}
            type="date"
            value={filters?.dateFrom}
            onChange={(e) => setFilters({ ...filters, dateFrom: e?.target?.value })}
          />
          <Input
            label={dateToLabel?.[language]}
            type="date"
            value={filters?.dateTo}
            onChange={(e) => setFilters({ ...filters, dateTo: e?.target?.value })}
          />
          <Input
            label={ownerLabel?.[language]}
            type="text"
            placeholder={language === 'fr' ? 'Nom du propriétaire' : language === 'ar' ? 'اسم المالك' : 'Owner name'}
            value={filters?.owner}
            onChange={(e) => setFilters({ ...filters, owner: e?.target?.value })}
          />
        </div>
      )}
    </div>
  );
};

export default SearchBar;